export default "__VITE_ASSET__CE$Y_2vu__"